export const getAuthorizationToken = () => {
  const fullToken = localStorage.getItem('admin-token') as any
  const { idToken } = fullToken ? JSON.parse(fullToken) : { idToken: '' }
  return idToken
}
